// =============================================================================
// Agent Types
// =============================================================================
/** Supported agent identifiers */
export const AGENT_TYPE_VALUES = [
    'claude-code',
    'openai-codex',
    'google-gemini',
    'mistral-vibe',
    'opencode',
    'amp',
];
/** API key provider identifiers */
export const AGENT_PROVIDER_VALUES = [
    'anthropic',
    'openai',
    'google',
    'mistral',
    'opencode',
    'amp',
];
// =============================================================================
// Agent Catalog
// =============================================================================
/** All supported agents and their configuration */
export const AGENT_CATALOG = [
    {
        id: 'claude-code',
        name: 'Claude Code',
        description: "Anthropic's AI coding agent",
        provider: 'anthropic',
        envVarName: 'ANTHROPIC_API_KEY',
        acpCommand: 'claude-agent-acp',
        acpArgs: [],
        supportsAcp: true,
        credentialHelpUrl: 'https://console.anthropic.com/settings/keys',
        installCommand: 'npm install -g @zed-industries/claude-agent-acp',
        oauthSupport: {
            envVarName: 'CLAUDE_CODE_OAUTH_TOKEN',
            setupInstructions: 'Generate a token using "claude setup-token" or "claude login" in your terminal',
            subscriptionUrl: 'https://claude.ai/settings/plan',
        },
    },
    {
        id: 'openai-codex',
        name: 'OpenAI Codex',
        description: "OpenAI's AI coding agent",
        provider: 'openai',
        envVarName: 'OPENAI_API_KEY',
        acpCommand: 'codex-acp',
        acpArgs: [],
        supportsAcp: true,
        credentialHelpUrl: 'https://platform.openai.com/api-keys',
        installCommand: 'npx --yes @zed-industries/codex-acp --version',
        oauthSupport: {
            envVarName: 'CODEX_AUTH_JSON',
            setupInstructions: 'Run "codex login" on your local machine and sign in with your ChatGPT account, then paste the contents of ~/.codex/auth.json',
            subscriptionUrl: 'https://openai.com/chatgpt/pricing/',
        },
    },
    {
        id: 'google-gemini',
        name: 'Gemini CLI',
        description: "Google's AI coding agent",
        provider: 'google',
        envVarName: 'GEMINI_API_KEY',
        acpCommand: 'gemini',
        acpArgs: ['--acp'],
        supportsAcp: true,
        credentialHelpUrl: 'https://aistudio.google.com/apikey',
        installCommand: 'npm install -g @google/gemini-cli',
    },
    {
        id: 'mistral-vibe',
        name: 'Mistral Vibe',
        description: "Mistral AI's coding agent",
        provider: 'mistral',
        envVarName: 'MISTRAL_API_KEY',
        acpCommand: 'vibe-acp',
        acpArgs: [],
        supportsAcp: true,
        credentialHelpUrl: 'https://console.mistral.ai/api-keys',
        installCommand: 'curl -LsSf https://astral.sh/uv/install.sh | UV_INSTALL_DIR=/usr/local/bin sh && UV_TOOL_DIR=/opt/uv-tools UV_PYTHON_INSTALL_DIR=/opt/uv-python UV_TOOL_BIN_DIR=/usr/local/bin uv tool install mistral-vibe==2.7.0 --python 3.12 --quiet',
    },
    {
        id: 'opencode',
        name: 'OpenCode',
        description: 'Open-source AI coding agent by SST. Uses Scaleway Generative APIs for inference.',
        provider: 'opencode',
        envVarName: 'SCW_SECRET_KEY',
        acpCommand: 'opencode',
        acpArgs: ['acp'],
        supportsAcp: true,
        credentialHelpUrl: 'https://console.scaleway.com/iam/api-keys',
        fallbackCloudProvider: 'scaleway',
        installCommand: 'npm install -g opencode-ai@1.4.3',
    },
    {
        id: 'amp',
        name: 'Amp',
        description: "Sourcegraph's managed AI coding agent",
        provider: 'amp',
        envVarName: 'AMP_API_KEY',
        acpCommand: 'acp-amp',
        acpArgs: ['run'],
        supportsAcp: true,
        credentialHelpUrl: 'https://ampcode.com/settings',
        installCommand: 'curl -LsSf https://astral.sh/uv/install.sh | UV_INSTALL_DIR=/usr/local/bin sh && UV_TOOL_DIR=/opt/uv-tools UV_PYTHON_INSTALL_DIR=/opt/uv-python UV_TOOL_BIN_DIR=/usr/local/bin uv tool install acp-amp==0.1.3 --with agent-client-protocol==0.7.1 --with amp-sdk==0.1.2 --with pydantic==2.12.5 --with pydantic-core==2.41.5 --with annotated-types==0.7.0 --with typing-inspection==0.4.2 --with typing-extensions==4.15.0 --python 3.12 --quiet && npm install -g @sourcegraph/amp',
    },
];
/** Look up an agent definition by ID */
export function getAgentDefinition(agentType) {
    return AGENT_CATALOG.find((a) => a.id === agentType);
}
/** Validate that a string is a valid agent type */
export function isValidAgentType(value) {
    return AGENT_CATALOG.some((a) => a.id === value);
}
//# sourceMappingURL=agents.js.map